module.exports = __webpack_public_path__ + "img/70.dc8a0f24.png";